<template>
    <div>
        <span>
            {{ $formatters.formatCurrency(cDistance) }}
        </span>
        km
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { $formatters } = useNuxtApp()

const { params } = toRefs(props)

const CKeyDistance = computed(() => {
  return params?.value?.keyDistance || 'distance'
})

const cDistance = computed(() => {
  if (CKeyDistance.value === 'tolerance') {
    return params?.value?.data?.tolerance
  }

  if (CKeyDistance.value === 'totalKm') {
    return params?.value?.data?.totalDistance || 0
  }

  const routingPositions = params?.value?.data?.routingPositions || {}
  const distance = routingPositions?.route?.distance || 0
  return distance
})
</script>
